import { LanguageKeys } from '#/@types/translate'

const es: LanguageKeys = {
    '2nd': '2.°',
    '3rd': '3.°',
    '403_fallback_message': 'No tienes permiso para acceder a esta página. Si crees que esto es un error, contacta con el soporte técnico.',
    '403_fallback_title': 'Acceso no autorizado',
    '404_fallback_message': 'No pudimos encontrar la página que está buscando.',
    '404_fallback_title': 'página no encontrada!',
    '429_fallback_message': 'Parece que estás navegando demasiado rápido entre pantallas. Para garantizar la seguridad de tu cuenta y mantener la calidad de tu experiencia, te pedimos que esperes un momento antes de continuar.',
    '429_fallback_title': 'cálmate... ¡respira!',
    '500_fallback_title': 'lo siento, algo va mal!',
    'abortion': 'aborto',
    'accept': 'aceptar',
    'access': 'acceso',
    'access_farm_ccoms': 'Acceder a los C-Coms de la granja',
    'access_item': 'acceder {item}',
    'access_management': 'gestión de accesos',
    'accesses': 'accesos',
    'account': 'cuenta',
    'account_plural': 'cuentas',
    'accumulated': 'acumulativo',
    'accumulated_behavior': 'comportamiento acumulativo',
    'action_completed': '¡Acción completada con éxito!',
    'activate': 'activar',
    'active_contracts': 'contratos activos',
    'active_female_plural': 'activas',
    'active_female_singular': 'activa',
    'active_male': 'activo',
    'activity': 'actividad',
    'actual_batch': 'lote actual',
    'add_condition': 'añadir condición',
    'add_group': 'añadir grupo',
    'add_item': 'añadir {item}',
    'add_new_option': 'añadir nueva entrada {item}',
    'add_permissions_to_page': 'añadir permisos a la página',
    'add_permissions_to_roles': 'añadir permisos a los roles',
    'add_to_another_protocol': 'agregar a otro protocolo',
    'add-to-an-existing-protocol': 'añadir a un protocolo existente',
    'additional_info': 'información complementaria',
    'address': 'dirección',
    'adjustments': 'ajustes',
    'age_at_first_calving': 'edad al primer parto',
    'ai': 'IA',
    'AI': 'IA',
    'ai_apresentation_description': 'Cuanto más específica sea la pregunta, mejor podré responderte',
    'ai_apresentation_title': '¿Cómo puedo ayudarte hoy?',
    'ai-hormone-implanted': 'IH-IATF',
    'aimer_cameras': 'cámaras Aimer',
    'aimer_cameras_overview':
        'La integración con Aimer conecta los datos de monitoreo por cámaras a CowMed, permitiendo acompañar el comportamiento alimentario de los lotes. Las cámaras analizan continuamente el comedero y envían indicadores que ayudan a identificar la disponibilidad de alimento, la ocupación y la necesidad de manejo.\n\nPara saber cómo tener este recurso en su granja, hable con los consultores comerciales de CowMed.\n\n### Cómo funciona\n\n1. Para utilizar la integración, el servicio de monitoreo por cámaras de Aimer debe estar instalado y operativo en la granja. Puede contratar el servicio a través de nuestro equipo comercial.\n2. Después de la instalación, solicite la activación de la integración a los técnicos de Aimer o al equipo de consultores de CowMed.\n3. Con la integración activa, los lotes de Aimer se vinculan a los lotes correspondientes registrados en CowMed.\n4. Después de la configuración, los indicadores y alertas generados por las cámaras pasan a mostrarse en el contexto de Nutrición de la granja.\n\n### Datos disponibles\n\n- Puntaje de comedero\n- Tiempo diario de comedero vacío\n- Tiempo de espera\n- Alertas de necesidad de Push Up',
    'alert_count': 'conteo de alertas',
    'alert_hourly': 'alertas por horario',
    'alert_plural': 'alertas',
    'alert_utilization': 'aprovechamiento de alertas',
    'alerted_plural': 'alertados',
    'all_female': 'todos',
    'all_male': 'todos',
    'all_markings': 'todas las marcaciones',
    'analysis': 'análisis',
    'and': 'y',
    'animal': 'animal {item}',
    'animal_behavior': 'comportamiento animal',
    'animal_condition_today': '¿cómo es el estado del animal hoy?',
    'animal_departure': 'salida de animales',
    'animal_discard': 'descarte de animales',
    'animal_gender': '¿cuál es el sexo de la ternera?',
    'animal_in_protocol': 'animal en el protocolo',
    'animal_lists': 'listas de animales',
    'animal_name': 'nombre del animal',
    'animal_plural': 'animales {item}',
    'animals': 'animales',
    'animals_a_protocol': 'animales a un protocolo',
    'animals_for_review': 'animales para repasar',
    'animals_in_withdrawal': 'animales en retirada',
    'animals_into_protocol': 'animales al protocolo',
    'answered_at': 'respondido en',
    'api': 'api',
    'application': 'aplicación',
    'applications': 'aplicaciones',
    'applied': 'aplicada',
    'applied_plural': 'aplicadas',
    'apply': 'aplicar',
    'archive_item': 'archivar {item}',
    'archived': 'archivado',
    'assign_normal_status_to_animal': 'asignar un estado Normal a este animal',
    'attach_collar': 'vincular collar',
    'attach_item': 'vincular {item}',
    'attach_permissions_to_roles': 'vincular permisos a roles',
    'attached_batches': 'lotes vinculados',
    'attached_collar': 'collar vinculado',
    'attachment': 'vínculo',
    'authorize': 'autorizar',
    'auto_filled_data': 'datos autocompletados',
    'automatically_detected': '{item} detectado automáticamente',
    'available_integrations': 'integraciones disponibles',
    'available_plural': 'disponibles',
    'available_singular': 'disponible',
    'average_birth_weight': 'Peso promedio al nacer',
    'average_daily_gain': 'ganancia media diaria',
    'average_data_stack_percentage': 'porcentaje promedio de la pila de datos',
    'average_DEL': 'DEL medio',
    'average_panting': 'respiración promedio {item}',
    'average_rumination': 'rumia promedio {item}',
    'average_weaning_weight': 'Peso promedio al destete',
    'b2b_screens': 'pantallas B2B',
    'b2c_screens': 'pantallas B2C',
    'back': 'volver',
    'back_to_cowmed': 'volver a Cowmed',
    'batch': 'lote',
    'batch_average_plural': 'media de los lotes',
    'batch_diet': 'dieta por lotes',
    'batch_divergence': 'animales fuera de lote',
    'batch_divergence_alert': 'La ubicación se determina en función de la concentración de paquetes enviados por los collares a las antenas. Fallas recientes de comunicación pueden afectar la ubicación mostrada. Mantenga siempre actualizada la información sobre los movimientos de los animales entre lotes.',
    'batch_monitoring': 'monitoreo del lote',
    'batch_move_fail': 'error al mover el lote',
    'batch_move_success': 'lote movido con éxito',
    'batch_plural': 'lotes',
    'battery_voltage': 'voltaje de la batería',
    'best_bull_mating': 'El mejor toro para el apareamiento',
    'best_time_for_ai': 'mejor momento para IA/MN',
    'birth': 'nacimiento',
    'birthday': 'fecha de nacimiento',
    'blog_and_news': 'blog y noticias',
    'blog_and_news_description': 'novedades y contenido',
    'body_assessment': 'evaluación corporal',
    'body_score': 'condición corporal',
    'boxplot_high': 'máximo',
    'boxplot_low': 'mínimo',
    'boxplot_median': 'mediana',
    'boxplot_q1': 'Q1',
    'boxplot_q3': 'Q3',
    'brazilian_holstein_cattle_association': 'Asociación Brasileña de Ganado Holandés',
    'break': 'romper',
    'breathing': 'respiración',
    'breathing_status_changed': 'estado respiratorio alterado',
    'brix': 'brix',
    'browser_guard_benefits': 'Mantener el navegador actualizado ayuda a garantizar mayor seguridad, mejor rendimiento y el funcionamiento correcto de todas las funcionalidades disponibles.',
    'browser_guard_benefits_mac': 'Safari se actualiza junto con macOS, por lo que la actualización debe hacerse desde el sistema. Si lo prefiere, también puede acceder al sistema con otro navegador, como Chrome, Edge, Firefox u Opera.',
    'browser_guard_confirm_checkbox': 'Declaro que soy consciente de que la versión de mi navegador no es compatible con la versión mínima recomendada y que esto puede causar errores o comportamientos inesperados.',
    'browser_guard_download_tooltip': 'Ir a la página de descarga de {browser}',
    'browser_guard_eyebrow': 'Actualización necesaria',
    'browser_guard_footer': 'Actualice su navegador a la versión más reciente y recargue esta página. Si lo prefiere, también puede acceder al sistema utilizando otro navegador.',
    'browser_guard_footer_feature': 'Para continuar, acceda al sistema con un navegador actualizado, como Chrome, Edge, Firefox u Opera.',
    'browser_guard_footer_ios': 'Para actualizar, abra Ajustes > General > Actualización de software e instale la versión más reciente disponible. Luego, vuelva a esta página e inténtelo nuevamente.',
    'browser_guard_footer_mac': 'Para actualizar, abra Ajustes del Sistema > General > Actualización de software e instale la versión más reciente disponible. Luego, vuelva a esta página e inténtelo nuevamente.',
    'browser_guard_installed_version_label': 'Versión instalada',
    'browser_guard_message': 'Identificamos que está utilizando {detectedBrowser}, que está por debajo de la versión mínima soportada ({minimumBrowser}) para este sistema.',
    'browser_guard_message_feature': 'Identificamos que está utilizando {detectedBrowser}, que no es compatible con los recursos necesarios para este sistema.',
    'browser_guard_message_ios': 'El sistema de su dispositivo está desactualizado y no es compatible con esta página. Para seguir usando el sistema CowMed, actualice su iPhone o iPad a {minimumBrowser} o más reciente.',
    'browser_guard_message_mac': 'El Safari de su Mac está desactualizado y no es compatible con esta página. Para seguir usando el sistema CowMed, actualice macOS para obtener {minimumBrowser} o más reciente.',
    'browser_guard_proceed_button': 'Avanzar',
    'browser_guard_title': 'Su navegador necesita ser actualizado',
    'browser_guard_title_feature': 'Su navegador no es compatible',
    'browser_guard_title_ios': 'Su iPhone o iPad necesita ser actualizado',
    'browser_guard_title_mac': 'Su Safari necesita ser actualizado',
    'browser_guard_update_ios_tooltip': 'Ver cómo actualizar iOS',
    'browser_guard_update_mac_tooltip': 'Ver cómo actualizar Safari',
    'bull_losses': 'pérdidas por toro',
    'bull_migration': 'Migración de toros',
    'bull_or_semen': 'Toro / Semen',
    'bull_or_semen_archive_message': 'El toro / semen ya no está disponible para uso en la granja:\n\n- Ya no puede utilizarse como padre de un animal;\n- Ya no puede utilizarse en el registro de servicios;\n- Ya no puede utilizarse en el registro de apareamientos;\n- Sus apodos son eliminados.\n\n¡Todo el historial se mantiene y puede consultarse en cualquier momento!',
    'bull_or_semen_migration_message': 'Temporalmente, los registros de la granja deben seguir realizándose en la lista antigua de Toro / Semen. La nueva lista solo se utilizará después de la migración completa de los datos a la nueva estructura.',
    'bull_or_semen_remove_warning': 'al eliminar, todo el historial relacionado con este toro/semen será eliminado',
    'bunk_score': 'puntuación de comedero',
    'c_com': 'C-Com {item}',
    'c_com_communication_status': 'Estado de comunicación de C-com',
    'c_com_details': 'detalles c-com',
    'c_com_managment': 'gestión de antenas',
    'c_com_map': 'mapa de estado de c-com',
    'c_com_plural': 'C-Com {item}',
    'c_com_primary': 'C-Coms primarias',
    'c_com_secondary': 'C-Coms secundarias',
    'c_com_status': 'estado de la c-com',
    'c_tech': 'C-Tech {item}',
    'caesarean_surgery': 'cesárea o cirugía',
    'calf': 'ternero',
    'calf_condition': 'condición de ternero',
    'calf_plural_female': 'terneras',
    'calf_unknown': 'ternero(a)',
    'calvin_complication': '¿El parto tuvo alguna complicación?',
    'calvin_estimate': 'previsión del parto',
    'calving': 'parto',
    'calving_dificulty': 'dificultad en el parto',
    'calving_event': 'evento de parto',
    'calving_event_plural': 'eventos de parto',
    'calving_interval': 'IEP',
    'calving_plural': 'partos',
    'calving_procedure': 'procedimiento de parto',
    'calving_projection': 'proyección de parto',
    'camera_batches': 'cámaras',
    'campaign': 'campaña',
    'campaigns': 'campañas',
    'cancel': 'cancelar',
    'cancel_item': 'cancelar {item}',
    'cancellation': 'rescisión del contrato',
    'cancellation_reason': 'motivo de cancelación',
    'cancellation_request': 'solicitud de cancelación',
    'card_view': 'tarjetas',
    'case': 'casos',
    'categories': 'categorías',
    'category': 'categoría',
    'ccom_list': 'lista de C-Com',
    'ccom_map': 'mapa de C-Com',
    'CCS_or_CBT': 'CCS / CBT',
    'challenge': 'desafío',
    'challenged_animals': 'animales en desafio',
    'change_animal': 'cambio de animales',
    'change_collar_between_animals': 'cambio de collar entre animales',
    'change_collars': 'cambio de collares',
    'change_cow_comfort_between_points': 'cambio de CowComfort entre puntos',
    'change_group': 'cambio por lotes',
    'change_group_plural': 'cambio de lotes',
    'change_image': 'cambiar imagen',
    'change_of_item': 'cambio de {item}',
    'change_password': 'cambiar contraseña',
    'change_password_confirmation': 'Se enviará un correo electrónico con instrucciones para renovar la contraseña al usuario {userName} ({userEmail}). ¿Quieres confirmar la acción?',
    'change_to_heifer': 'pasar a novilla',
    'charged': 'cargado',
    'charger_active': 'cargador',
    'charging': 'cargando',
    'chart_type_column': 'cambiar a gráficos de columnas',
    'chart_type_line': 'cambiar a gráficos de líneas',
    'chart_type_restore': 'restaurar gráfico',
    'chat_deleted_successfully': 'chat eliminado con éxito!',
    'chat_plural': 'chats',
    'check_all_as_read': 'Marcar todo como leído',
    'check_as_read': 'marcar como leído(s)',
    'choose_field': 'elegir campo',
    'city': 'ciudad',
    'clear': 'limpiar',
    'client': 'cliente',
    'clinical_opinion': 'opinión clínica',
    'close': 'cerrar',
    'closure_by': 'cierre por',
    'collar': 'collar {item}',
    'collar_down_sell': 'down sell',
    'collar_event_received_at': 'transmisión de C-Com',
    'collar_interval': 'rango de collares',
    'collar_link': 'vinculo del collar',
    'collar_managment': 'gestión del collar',
    'collar_managment_plural': 'gestión de collares',
    'collar_map': 'mapa de informe de collar',
    'collar_plural': 'collares {item}',
    'collar_status': 'estado del collar',
    'collar_up_sell': 'up sell',
    'collected_milk': 'leche recolectada',
    'collection': 'recolección',
    'colostration': 'calostrado',
    'colostrum_type': 'tipo de calostro',
    'column_order': 'orden de columnas',
    'comfortable': 'cómodo',
    'comment': 'comentario',
    'comment_plural': 'comentarios',
    'commercial_condition_description': 'descripción de la condición comercial',
    'commercial_products': 'productos comerciales',
    'common_status': 'estado común',
    'communication_abbreviation': 'com',
    'communications': 'comunicaciones',
    'compact': 'compacto',
    'company': 'empresa',
    'company_answers': 'respuestas empresas',
    'company_contacts': 'contactos de empresa',
    'company_plural': 'compañías',
    'compare_with': 'comparar con',
    'complement': 'complemento',
    'concentrate': 'enfocado',
    'conception': 'concepción',
    'conception_per_DEL': 'diseño por DEL',
    'conception_rate': 'tasa de concepción',
    'condition': 'condición',
    'config_item': 'configurar {item}',
    'configured_by_cowmed_team': 'configurada por el equipo CowMed',
    'confirm_item': 'confirmar {item}',
    'confirmation': '{item} confirmación',
    'confirmation_of_item': 'confirmación de {item}',
    'confirmed_at': 'confirmado en',
    'confirmed_by': 'Confirmado por',
    'confirmed_plural': 'confirmados',
    'connect': 'conectar',
    'connected': 'conectada',
    'connected_services': 'servicios conectados',
    'connectivity': 'conectividad',
    'contract': 'contrato',
    'contract_address': 'dirección (contrato)',
    'contract_first_payment': 'primer pago',
    'contract_plural': 'contratos',
    'contract_start_date': 'fecha de inicio del contrato',
    'contract_summary': 'resumen del contrato',
    'contracted_plan': 'plan contratado',
    'cookie_consent': 'Utilizamos cookies para evaluar y analizar el uso de las funciones del software con el fin de mejorar y perfeccionar la experiencia del usuario. Al aceptar, nos autoriza a recopilar y utilizar esta información. Gracias por su contribución.',
    'coordinates': 'coordenadas',
    'copied_text_successfully': 'texto copiado al portapapeles',
    'copy': 'copiar',
    'copy_all': 'copiar todos',
    'copy_unprocessed': 'copiar ids no procesados',
    'corporate_name': 'nombre de la empresa',
    'correct_item': 'corregir {item}',
    'country': 'país',
    'cow_analytics': 'cow analytics',
    'cow_analytics_calving_text': 'Vacas gestantes cercanas a la fecha de parto, actualmente en fase de preparto',
    'cow_analytics_conception_text': 'Análisis de la eficiencia de los servicios de la finca',
    'cow_analytics_discard_text': 'Tasa de descarte y análisis de motivos de descarte',
    'cow_analytics_drying_text': 'Vacas gestantes cercanas a la fecha de secado',
    'cow_analytics_gestational_loss_text': 'analiza las pérdidas embrionarias y fetales en el embarazo',
    'cow_analytics_health_text': 'Analiza los resultados de las buenas prácticas sanitarias en tu explotación',
    'cow_analytics_heat_monitoring_text': 'Eficiencia de la detección de celo y el aprovechamiento de las alertas en la granja',
    'cow_analytics_heat_return_text': 'Animales que están cerca del período de retorno del celo.',
    'cow_analytics_marked_as': 'animales marcados como: descarte, inducción, inapta y protocolo',
    'cow_analytics_milk_control_text': 'acompaña la producción y la calidad de la leche del rebaño',
    'cow_analytics_pre_calving_prediction_text': 'Vacas preñadas cerca de la entrada antes del parto',
    'cow_analytics_pregnancy_diagnosis_text': 'Vacas tardías esperando diagnóstico de preñez',
    'cow_analytics_rearing_text': 'Evalúa el desarrollo de animales jóvenes en tu granja',
    'cow_analytics_services_text': 'Análisis de los servicios realizados en la finca',
    'cow_analytics_transition_text': 'análisis e informes sobre el período de transición',
    'cow_analytics_wellness_text': 'Evalúe el estado de confort térmico, descanso y consumo de sus animales',
    'cow_baby': 'CowBaby',
    'cow_comfort': 'CowComfort {item}',
    'cow_comfort_managment': 'gestión de CowComfort',
    'cow_connect': 'CowConnect',
    'cow_plural': 'vacas {item}',
    'cowbaby_expired': 'Baby caducada',
    'cowconnect_payment_start': 'contrato CowConnect',
    'cowsync': 'cowsync',
    'create_item': 'registrar {item}',
    'created_at': 'creado en',
    'created_by': 'creado por',
    'created_item_at': '{item} Creado en',
    'critical': 'serio',
    'critical_dim_without_pregnancy': 'Del alto sin embarazo',
    'crop': 'recortar',
    'cross_sell_cowconnect_plan': 'cross sell para CowConnect',
    'cross_sell_monitoring_plan': 'cross sell para CowMed Monitoreo',
    'cs': 'cs',
    'ctech_possible_removal_message': 'Estas correas están vinculadas a animales, pero sin actividad registrada, posiblemente removidas o perdidas. Verifique y actualice el vínculo o contacte al soporte CowMed.',
    'ctech_waiting_attachment_message': 'estas correas están en perfectas condiciones de funcionamiento, pero están instaladas en un animal que aún no ha sido registrado en el sistema.',
    'current_farm_entry': 'entrada a finca actual',
    'custom_list': 'lista personalizada',
    'customer_center': 'centro del cliente',
    'customization': 'personalización',
    'cycle': 'ciclo',
    'cycling_rate': 'cycling rate',
    'cycling_rate_accumulated': 'cycling rate acumulativo',
    'daily_behavior_slash_production': 'comportamiento diario / producción',
    'daily_meals': 'comidas diarias',
    'dashboard': 'dashboard',
    'data': 'dato',
    'data_from_date': 'datos de {date}',
    'data_interval': 'rango de datos',
    'data_interval_per_batch': 'rango de datos por lote',
    'data_not_recognized': 'datos no reconocidos',
    'data_plural': 'datos',
    'data_stack_max_percentage': 'porcentaje máximo de pila de datos',
    'data_to_be_processed': 'datos a procesar',
    'data_update': 'actualización de datos',
    'data_view': 'vista de datos',
    'data_view_benchmarking_text': 'Consulta el ranking de rendimiento de las granjas monitoreadas por Cowmed',
    'data_view_contracts_text': 'análisis operativo de cuentas y contratos',
    'data_view_contracts_title': 'cuentas y contratos',
    'datagrid_actions': 'acción',
    'datagrid_config_message': 'las configuraciones definidas en esta sección se aplican solo localmente en su navegador. no afectan la exportación de datos, sirviendo solo para facilitar la visualización de la tabla.',
    'datagrid_config_title': 'importante',
    'datagrid_records_info': 'registro {from} a {to} de {total}',
    'datagrid_results_per_page': 'resultados por página:',
    'datatable_no_records_found': 'no se encontraron registros',
    'date': 'fecha',
    'date_after_maximal': 'La fecha no debe ser posterior a la fecha máxima',
    'date_before_minimal': 'La fecha no debe ser anterior a la fecha mínima',
    'date_format_long': 'DD/MM/YYYY',
    'date_format_long_timestamped': 'DD/MM/YYYY HH:mm',
    'date_milk_production': 'Fecha de producción lechera',
    'date_of_marking': 'día de la cita',
    'datepicker_last_days': 'últimos {days} días',
    'datepicker_previous_month': 'mes pasado',
    'day': 'día',
    'day_monitoring': 'control diario',
    'days': 'días',
    'days_open': 'días abiertos',
    'DEA': 'DEA',
    'deactivate': 'desactivar',
    'death_method': 'método de eliminación',
    'default': 'estándar',
    'default_values': 'valores iniciales',
    'DEL': 'DEL',
    'DEL_long_text': 'días en leche',
    'delay_ccom_legend': 'datos referentes al estado de la primera hora',
    'delay_legend': 'Escala de colores según el retraso en el envío de datos:',
    'delete_inapt': 'Al deshacer esta marca, la vaca se considera apta durante el período de marca. Este registro se utiliza para corregir errores de marcado. Si solo desea liberar esta vaca a partir de hoy y hacer que se ajuste, le sugerimos que registre el evento "desmarcar como".',
    'delete_inapt_message': '¿Está seguro de que desea eliminar la etiqueta?',
    'delete_permanently': 'eliminar definitivamente',
    'deleted_at': '{item} eliminado el',
    'delivery_address': 'dirección de entrega',
    'departure_kind': 'tipo de salida',
    'departure_reason': 'motivo de salida',
    'dependent': 'dependiente',
    'description': 'descripción',
    'designed_by': 'proyectado por',
    'desynchronized': 'desincronizada',
    'detach_collar': 'desenlazar el collar',
    'detach_item': 'desvincular {item}',
    'detached_collar': 'collar desatado',
    'details': 'detalles',
    'detected': 'detectado {item}',
    'detected_at': '{item} detectado en',
    'detection_method': 'método de detección',
    'developer_mode': 'modo desarrollador',
    'developer_mode_description': 'recursos para desarrollo',
    'device_label': 'dispositivo',
    'device_list': 'lista de dispositivos',
    'device_renewal': 'renovación de dispositivos',
    'device_status': 'estado del dispositivo',
    'device_status_plural': 'estado de los dispositivos',
    'diagnosed_animals': 'animales diagnosticados',
    'diagnostic': 'diagnóstico',
    'diagnostic_plural': 'diagnósticos',
    'did_the_animal_exhibit_any_abnormal_behavior': '¿El animal mostró algún comportamiento anormal?',
    'diet_handling': 'tracto',
    'diet_initials': 'D',
    'diet_label': 'dieta',
    'diet_setup': 'registro de dietas',
    'difference_between_minimum_maximum': 'diferencia entre índice mínimo y máximo',
    'difficult_assistance': 'difícil (con ayuda)',
    'difficult_vet_care': 'difícil (atención veterinaria)',
    'dim_first_service_dispersion': 'dispersión 1.er servicio',
    'dim_losses': 'pérdidas por del',
    'DIM_on_first_service': 'DEL en el 1.° servicio',
    'DIM_on_first_service_help_message': 'Muestra los días de lactancia en el momento del primer servicio de los animales y la eficiencia en la concepción. Solo tiene en cuenta los servicios realizados después de 30 días, lo que garantiza el tiempo mínimo necesario para el diagnóstico de gestación',
    'discard': 'descartar',
    'discard_collar': 'desechar el collar',
    'discard_cow_comfort': 'descarte CowComfort',
    'discard_moment': 'momento de descarte',
    'discard_out': 'descarte / salida',
    'discard_plural': 'descartes',
    'discard_rate': 'tasa de descarte',
    'discard_reason': 'motivo de descarte',
    'discard_register': 'registro de descarte/venta/eliminación',
    'discard_total': 'descarte total',
    'discarded_animals': 'animales desechados',
    'discarded_or_deleted': '{item}\ndescartado/eliminado',
    'disconnect': 'desconectar',
    'disconnect_integration_alert': 'la configuración de la integración será eliminada y deberá informarse nuevamente para conectar.',
    'disconnected': 'desconectadas',
    'disconnected_singular': 'desconectada',
    'dnd_drag_animals_to_batch': 'para añadir animales al lote, arrástralos a esta columna',
    'dnd_drag_to_column': 'arrastra elementos a esta columna',
    'dnd_drag_to_define_order': 'arrastra los campos para definir el orden de visualización en la tabla',
    'do_you_really_want_to_item': '¿realmente quieres {item} {id}?',
    'do_you_really_want_to_reverse_archive_item': '¿Está seguro de que desea revertir la archivación del {item} {id}?',
    'do_you_really_want_to_revert_this_application': '¿Está seguro de que desea revertir esta aplicación?',
    'document_date_format': 'formato de la fecha del documento',
    'donor': 'donante',
    'donor_plural': 'donadoras',
    'download': 'descarga',
    'download_app': 'descargar la aplicación Cowmed',
    'download_file': 'descargar archivo',
    'download_pdf': 'descargar archivo pdf',
    'download_png': 'descargar imagen png',
    'download_results': 'descargar resultados',
    'download_spreadsheet': 'descargar hoja de calculo {item}',
    'download_template_spreadsheet': 'descargar la plantilla de la hoja de cálculo',
    'download_xls': 'descargar archivo XLS',
    'dry': 'seco',
    'dry_event_plural': 'eventos de secado',
    'dry_reason': 'motivo del secado',
    'drying': 'secado',
    'drying_projection': 'proyección de secado',
    'DTR_initials': 'DTR',
    'DUI_long_text': 'días última inseminación',
    'duplicate_item': 'duplicar {item}',
    'duplicate_role': 'duplicar rol',
    'easy_unassisted': 'fácil (asistido)',
    'edit_farm_bull_link': 'editar vínculo con toro de la granja',
    'edit_personal_info': 'editar información personal',
    'ein': 'RUC',
    'eligible_cow_plural': 'vacas aptas',
    'email': 'correo electrónico',
    'embryo_transfer': 'transferencia embrionaria',
    'embryo_type': 'tipo de embrión',
    'empty': 'vacío',
    'empty_animal': 'animal vacío',
    'empty_farm_profile_msg': 'Parece que aún no has registrado tu perfil para esta granja.',
    'empty_list': 'lista vacía',
    'empty_male': 'vacío',
    'empty_time': 'tiempo vacío',
    'empty-post-delivery': 'vacío PEV',
    'end_date': 'fecha final',
    'end_of_item_withdrawal': 'fin del período de retiro de {item}',
    'end_of_messages': 'fin de mensajes',
    'engagement': 'compromiso',
    'environmental_comfort': 'análisis de THI',
    'error_500': 'Se ha producido un error. Lo siento por los inconvenientes ocasionados. Si el problema persiste, envíe un correo electrónico a software@cowmed.com.br indicando la acción tomada que provocó este error.',
    'error_deleting_chat': 'error al eliminar el chat',
    'error_maintenance': 'ERROR: Mantenimiento',
    'error_plural': 'errores',
    'error_sending_feedback': '¡Hubo un error al enviar sus comentarios!',
    'ET': 'TE',
    'et-hormone-implanted': 'IH-TETF',
    'evaluation_date': 'fecha de evaluación',
    'event': 'evento',
    'event_of_plural': 'eventos de {item}',
    'event_plural': 'eventos',
    'exit_fullscreen': 'salir de pantalla completa',
    'exitFullscreen': 'salir de pantalla completa',
    'export': 'exportar {item}',
    'export_data': 'exportar datos',
    'exportable': 'exportable',
    'exportation': 'exportar',
    'exporting': 'exportando...',
    'exports': 'exportaciones',
    'extra_modules': 'módulos adicionales',
    'failed': 'error de ejecución',
    'farm': 'granja',
    'farm_account_plural': 'cuentas de granja',
    'farm_address': 'dirección de la granja',
    'farm_answers': 'respuestas granjas',
    'farm_code': 'código de la granja',
    'farm_contract_plural': 'contratos de la granja',
    'farm_database': 'base de datos',
    'farm_distribution': 'distribución de la granja',
    'farm_list': 'lista de granjas',
    'farm_list_description': 'granjas disponibles para usted',
    'farm_management': 'manejo de la granja',
    'farm_name': 'nombre de la granja',
    'farm_OKR': 'OKR',
    'farm_plural': 'granjas',
    'farm_profile': 'Perfil de la granja',
    'farm_revision': 'revisión en la granja',
    'farm_settings': 'configuración de la granja',
    'farm_settings_description': 'red, OKR, usuarios y más',
    'farms_without_portfolio': 'granjas sin cartera',
    'fat_percentage': 'grasa (%)',
    'feed': 'tracto',
    'female': 'hembra',
    'fidelity': 'fidelidad',
    'field': 'campo',
    'file': 'archivo',
    'files': 'archivos',
    'fill_all_required_fields': 'complete todos los campos requeridos',
    'filter': 'filtrar',
    'final_value': 'valor final',
    'financing_modality': 'modalidad de financiación',
    'find_by_item': 'buscar por {item}',
    'find_item': 'encontrar {item}',
    'finish': 'terminar',
    'finished_at': 'terminado en',
    'fixed': 'fijas',
    'foetus': 'determinación del sexo',
    'for_discard': 'para descarte',
    'for_induction_lactation': 'para inducción de lactancia',
    'for_protocol': 'para protocolo',
    'forecast_return': 'previsión de retorno',
    'form_with_errors': '¡Ups! Encontramos algunos errores en el formulario. Corrige los campos resaltados para continuar con el registro.',
    'formbuilder_error_fetching_data_message': 'No se pudo cargar el formulario en este momento. Inténtalo nuevamente en unos instantes. Si el problema persiste, ponte en contacto con nuestro equipo para que podamos ayudarte lo antes posible.',
    'formbuilder_error_fetching_data_title': 'Error al cargar el formulario',
    'full': 'completo',
    'full_screen': 'ver en pantalla completa',
    'fullscreen': 'ver en pantalla completa',
    'gender': 'sexo',
    'general': 'general',
    'general_farm': 'general de la granja',
    'general_herd': 'rebaño general',
    'general_info_plural': 'Informaciones generales',
    'general_milk_control': 'control lechero general',
    'general_production': 'producción general',
    'general_spreadsheet': 'hoja general',
    'general_status': 'estado general',
    'general_wellness': 'bienestar general',
    'gestational_loss': 'pérdidas gestacionales',
    'global_search': 'Buscable por: Animal, Lote, Collar',
    'global_search_pages_and_farms': 'Buscable por: Granja, Página',
    'group_item': 'Grupo {number}',
    'growth_curve': 'curva de crecimiento',
    'gynecologic_examination': 'examen ginecológico',
    'handling': 'administración',
    'handling_events': 'eventos de manejo',
    'handling_register': 'registro de manejo',
    'health': 'salud',
    'health_alert_plural': 'alerta sanitaria',
    'health_event': 'evento de salud',
    'health_event_plural': 'eventos de salud',
    'health_protocols': 'protocolos de salud',
    'health_status': 'Estado de salud',
    'heat': 'celo',
    'heat_alert': 'alerta de celo',
    'heat_alert_plural': 'alertas de celo',
    'heat_detected': 'celos detectados',
    'heat_monitoring': 'monitoreo de celo',
    'heat_register_12_hours_before': 'registrar nuevo CELO (12 horas antes de la inseminación)',
    'heat_return': 'retorno al celo',
    'heat_strength': 'fuerza de celo',
    'heat_type_iatf': 'IATF',
    'heifer': 'novilla',
    'help': 'ayuda',
    'help_center': 'centro de ayuda',
    'help_us_understand_what_happened': 'ayúdanos a entender lo que pasó',
    'herd': 'rebaño',
    'herd_and_reproduction': 'rebaño + reproducción',
    'herd_and_reproduction_and_batches': 'rebaño + reproducción + lotes',
    'herd_and_reproduction_and_milk_control': 'rebaño + reproducción + control lechero',
    'herd_cow_analytics_card_text': 'analiza tu rebaño, evolución y distribución',
    'hexadecimal_key': 'clave hexadecimal',
    'hideData': 'ocultar tabla de datos',
    'highcharts_events': 'visualización de eventos',
    'highcharts_export': 'exportación de gráficos',
    'hint_register_farm_profile_msg': 'Empiece a registrar su perfil haciendo clic en el botón siguiente.',
    'historic': 'histórico',
    'home': 'inicio',
    'hospital_time': 'tiempo en enfermería',
    'hour_initials_plural': 'hrs',
    'hourly': 'hora/hora',
    'hourly_monitoring': 'monitorización horaria',
    'hours_over_limit': 'horas por encima del límite',
    'how_to_use': 'modo de uso',
    'humidity': 'humedad',
    'i_got_it': 'Ok, entendí',
    'ia_cob_te': 'IA/MN/TE',
    'identification': 'identificación',
    'ignore_temporarily': 'ignorar temporalmente',
    'ignore_temporarily_alert_message': 'al marcar un animal como "Ignorado temporalmente", se eliminará de la lista de enfermería durante 12 horas. Durante este período, si hay cambios en el estado, el diagnóstico o el tratamiento, el animal volverá automáticamente a la lista.',
    'ignore_temporarily_confirm_message': '¿Estás seguro de que deseas ignorar temporalmente este animal?',
    'image_load_error': 'No fue posible cargar la imagen',
    'implant_lost_initials': 'PI',
    'import': 'importación',
    'import_data': 'importar datos',
    'import_details': 'detalles de la importación',
    'import_discards': 'importar descartes',
    'import_item': 'importar {item}',
    'import_will_be_notified': 'Haga clic en Importar. Al final del proceso recibirá una notificación.',
    'imports': 'importaciones',
    'in_cancellation': 'en cancelación',
    'inactive_female': 'inactivo',
    'inactive_male': 'inactivo',
    'inactive_time': 'tiempo de inactividad',
    'inapt_for_reproduction': 'inapta para reproducción',
    'included_products': 'productos incluidos',
    'index': 'índice {item}',
    'individual_milk_control': 'control lechero individual',
    'individual_production': 'producción individual',
    'induced_lactation': 'lactancia inducida',
    'induction': 'inducción',
    'inductions_realized': 'inducciones realizadas',
    'ineligible_heifer_plural': 'novillas no aptas',
    'infirmary': 'enfermería',
    'info_short': 'información',
    'information_plural': 'informaciones',
    'ingredient': 'ingrediente',
    'ingredient_management': 'gestión de ingredientes',
    'initial_value': 'valor inicial',
    'inseminated': 'inseminada',
    'inseminated_plural': 'inseminadas',
    'insemination': 'inseminación',
    'inseminator': 'inseminador',
    'installed_by': 'instalado por',
    'intake_and_panting': 'consumo y respiración',
    'intake_and_rumination': 'consumo y rumia',
    'integrations': 'integraciones',
    'integrations_description': 'socios y servicios conectados a la granja',
    'intelligence_parameters': 'parámetros de inteligencia',
    'intensity': 'intensidad',
    'interaction': 'interacción',
    'international_register': 'registro internacional',
    'interval': 'intervalo',
    'interval_between_services': 'intervalo entre servicios',
    'invalid_date_format': 'formato de fecha inválido',
    'invalid_field': 'el campo "{item}" no es válido',
    'invalid_image_file': 'el archivo seleccionado no es una imagen',
    'invalid_latitude': 'Latitud no válida. Debe estar entre -90 y 90',
    'invalid_longitude': 'Longitud no válida. Debe estar entre -180 y 180',
    'inventory': 'inventario',
    'is_operating': 'está operando',
    'item_count_plural': '{item} elementos',
    'item_history': 'historia de {item}',
    'item_index': 'índice de {item}',
    'item_lat_lng_invalid': '{item} tiene una configuración de latitud/longitud inválida.',
    'item_limit_of': 'de {max} (límite)',
    'item_limits': 'límites de ítems',
    'item_monitored_plural': '{item} monitoreados',
    'item_selected_plural': '{item} seleccionado',
    'item_withdrawal': 'retiro de {item}',
    'lactating_animals': 'animales en lactación',
    'lactation': 'lactación',
    'lactation_induction': 'inducción de lactancia',
    'lactation_plural': 'lactancias',
    'lactose_percentage': 'Lactosa (%)',
    'language': 'idioma',
    'last_ai': 'última IA',
    'last_calving': 'último parto',
    'last_cloud_sync': 'última sincronización en la nube',
    'last_confirmation': 'última confirmación',
    'last_connection': 'última conexión',
    'last_feed': 'última alimentación',
    'last_insemination': '¿Cuándo fue la última inseminación de la vaca...',
    'last_link': 'último vinculo',
    'last_processed_at': 'procesado por última vez en',
    'last_read': 'última lectura',
    'last_report': 'último informe',
    'last_request': 'última solicitud',
    'last_status': 'último estado',
    'last_update': 'última actualización',
    'late_inseminated': 'inseminadas tarde',
    'late-inseminated': 'inseminado tarde',
    'latest_evaluation': 'última evaluación',
    'latitude': 'latitud',
    'lead_time_cm': 'lead time CM',
    'leisure': 'ociosidad',
    'less_details': 'menos detalles',
    'limit': 'límite',
    'link_to_farm_bull': 'vincular a toro de la granja',
    'linked_to_farm_bull': 'vinculado a toro de la granja',
    'list_view': 'lista',
    'lists': 'listas',
    'load_more': 'carga más',
    'loading': 'cargando',
    'loading_animal_info': 'cargando información del animal',
    'loading_batch_info': 'cargando información del lote',
    'loading_ccom_info': 'cargando información de CCom',
    'loading_cenv_info': 'cargando información de cowcomfort',
    'loading_chart_data': 'cargando datos del gráfico...',
    'loading_company_info': 'cargando información de la empresa',
    'loading_ctech_info': 'cargando información del collar',
    'loading_farm_info': 'cargando información de la granja',
    'loading_import_details': 'cargando detalles de la importación',
    'loading_just_a_moment': 'Espera un momento. Cargando...',
    'loading_list_info': 'cargando información de la lista',
    'loading_permission_farm': 'cargando permisos de la granja',
    'loading_production_info': 'cargando información de la producción',
    'loading_protocol_info': 'cargando información del protocolo',
    'loading_semen_info': 'cargando información del toro/semen',
    'loading_thi_info': 'cargando información de THI',
    'loading_user_info': 'cargando información del usuario',
    'loading_wait_a_moment': 'por favor espera un momento',
    'location': 'ubicación',
    'location_map': 'mapa de localización',
    'logout': 'salir',
    'longitude': 'longitud',
    'loss_rate': 'tasa de pérdidas',
    'lost_female_plural': 'perdidas',
    'low': 'bajo',
    'mac_address': 'MAC',
    'maintenance_plural': 'mantenimiento',
    'male': 'macho',
    'mammary_quarter': 'mama',
    'manage_account': 'Gestionar cuenta',
    'manage_account_and_password': 'administrar cuenta y contraseñas',
    'manage_item': 'gestionar {item}',
    'manage_password_and_access': 'gestiona la contraseña y las sesiones de tu cuenta',
    'manage_points': 'gestionar puntos',
    'management_system': 'sistema de gestión',
    'manufacturer': 'fabricante',
    'manufacturer_plural': 'fabricantes',
    'mark': 'marcar',
    'mark_as_item': 'marcar como {item}',
    'mark_as_not_applied_bulk_warning': '¿Está seguro de que desea marcar esto como no aplicadas?',
    'mark_as_not_applied_warning': '¿Está seguro de que desea marcar esto como no aplicada?',
    'marked_as': 'marcadas como',
    'marked_as_unfit': 'marcada como no apta para la reproducción',
    'marked_for_discard': 'marcada para eliminación',
    'marked_for_induction': 'marcada para la inducción de la lactancia',
    'marked_for_induction_plural': 'marcado para la inducción',
    'marked_for_protocol': 'marcada para protocolo',
    'marked_for_protocol_plural': 'marcadas para protocolo',
    'marking': 'marcación',
    'mastitis': 'mastitis',
    'mastitis_causative_agent': 'agente causante',
    'mastitis_dynamics': 'dinámica de mastitis',
    'mastitis_history': 'historial de mastitis',
    'mastitis_intensity_level': 'grado de intensidad',
    'mating': 'Apareamiento',
    'matrix': 'madre',
    'matrix_plural': 'madres',
    'meals': 'comidas',
    'meat': 'carne',
    'medication': 'medicamento',
    'mild_to_moderate_stress': 'estrés leve a moderado',
    'milk': 'leche',
    'milk_control': 'control lechero',
    'milk_control_and_batches': 'control lechero + lotes',
    'milk_production': 'producción de leche',
    'milk_production_date': 'indique la fecha del control lechero que desea importar. Sólo se procesarán los registros a partir de esta fecha.',
    'milking_item': 'ordeño {item}',
    'minute_initials': 'min',
    'model': 'modelo',
    'model_protocol': 'modelo de protocolo',
    'moderated': 'moderado',
    'module_permissions': 'permisos del módulo',
    'module_plural': 'módulos',
    'monitored_plural': 'monitoreados',
    'monitored_points': 'puntos monitoreados',
    'monitoring': 'monitoreo',
    'monitoring_activation': 'activación del monitoreo',
    'monitoring_contract': 'contrato de monitoreo',
    'monitoring_data': 'datos de monitoreo',
    'monitoring_point': 'punto de monitoreo',
    'month': 'mes',
    'monthly_losses': 'pérdidas mensuales',
    'months_april': 'abril',
    'months_august': 'agosto',
    'months_december': 'diciembre',
    'months_february': 'febrero',
    'months_january': 'enero',
    'months_july': 'julio',
    'months_june': 'junio',
    'months_march': 'marzo',
    'months_may': 'mayo',
    'months_november': 'noviembre',
    'months_october': 'octubre',
    'months_september': 'septiembre',
    'more': 'Saber más',
    'more_animals': '{count} animales más',
    'more_details': 'más detalles',
    'more_information': 'más información',
    'mortality': 'mortalidad',
    'most_accessed': 'más visitados',
    'move_collar_to': 'mover collar {item} a {location}',
    'move_cow_comfort_to': 'mover CowComfort {item} a {location}',
    'move_to': 'mover a {location}',
    'moved': 'movidas',
    'multiparous': 'multíparas',
    'multiselect_item': 'Ha seleccionado {quantity} artículo de su lista (hasta {max} ítems).',
    'multiselect_item_plural': 'Ha seleccionado {quantity} artículos de su lista (hasta {max} ítems).',
    'multiselect_register': 'Clica en el menú de opciones para grabar varios eventos simultáneamente.',
    'my_protocols': 'mis protocolos',
    'n_days': '{days} días',
    'name': 'nombre',
    'national_register': 'registro nacional',
    'natural_mating': 'monta natural',
    'navel_cure': 'cura del ombligo',
    'negotiated_condition': 'condición negociada',
    'network': 'la red',
    'new_attach': 'nuevo vínculo',
    'new_chat': 'nuevo chat',
    'new_conversation': 'nueva conversación',
    'new_item_female': 'nueva {item}',
    'new_item_female_plural': 'nuevas {item}',
    'new_item_male': 'nuevo {item}',
    'next': 'siguiente',
    'no': 'no',
    'no_active_integrations': 'no tienes ninguna integración activa',
    'no_available_integrations': 'no tienes ninguna integración disponible',
    'no_collar': 'sin collar',
    'no_data': 'sin datos',
    'no_data_after_hours': 'sin datos por más de {hours} horas',
    'no_data_between_hours': 'sin datos entre las últimas {from} hasta {to} horas',
    'no_data_to_view': 'no hay datos para visualizar',
    'no_item_limit': 'sin límite de ítems',
    'no_leading_zeros_in_day': 'sin ceros a la izquierda en el día',
    'no_leading_zeros_in_month': 'sin ceros a la izquierda en el mes',
    'no_limit': 'sin límite',
    'no_location_registered': 'ninguna ubicación registrada',
    'no_messages_to_show': 'no hay mensajes para mostrar',
    'no_processed_data': 'datos sin procesar',
    'no_reported_data': 'sin datos reportados',
    'no_results_found': 'no se encontraron resultados.',
    'no_service': 'sin servicio',
    'normal': 'normal',
    'normalize_item': 'normalizar {item}',
    'not_applied': 'no aplicada',
    'not_applied_plural': 'no aplicadas',
    'not_moved': 'no movido',
    'not_release': 'no liberar',
    'note': 'nota',
    'note_plural': 'notas',
    'notification_plural': 'notificaciones',
    'notification_settings_description': 'configura cómo recibir notificaciones',
    'nps': 'nps',
    'nps_reason_text': '¿Qué te ha motivado a dar esta puntuación?',
    'nps_score_text': 'en una escala de 0 a 10, ¿cuánto recomendarías CowMed?',
    'nps_subtitle': '¡Queremos garantizarle siempre la mejor experiencia!',
    'nps_title': '¡Vic quiere saber lo que piensas!',
    'number': 'número',
    'number_of_services': 'número de servicios',
    'nutrition': 'nutrición',
    'nutrition_and_intake': 'nutrición y consumo',
    'observation': 'observación',
    'of_day': 'del día',
    'of_week': 'de los últimos 7 días',
    'offline': 'offline',
    'op_between': 'entre',
    'op_equal': 'igual a',
    'op_greater': 'mayor que',
    'op_less': 'menor que',
    'op_not_equal': 'distinto de',
    'open_animal_plural': 'animales vacíos',
    'open_apt_heifers': 'vacía a los 15 meses',
    'open_c_com_managment': 'Abrir gestión de antenas',
    'operational': 'operacional',
    'operational_status': 'estado operacional',
    'operator': 'operador',
    'opportunities': 'oportunidades',
    'option': 'opción',
    'option_plural': 'opciones',
    'optional': 'opcional',
    'or': 'o',
    'order_date': 'fecha de solicitud',
    'ordering': 'ordenación',
    'other': 'otro',
    'other_information': 'otras informaciones',
    'other_software': 'Otros Softwares',
    'others': 'otros',
    'outdated_version_warning': 'estás utilizando una versión desactualizada de COWMED. Para garantizar el funcionamiento correcto del sistema y evitar errores o inconsistencias, la página se recargará automáticamente en {seconds} segundos.',
    'overall_average': 'media general',
    'overview': 'visión general',
    'owner_name': 'nombre del propietario',
    'panting': 'jadeo',
    'panting_hours': 'horas jadeantes',
    'password': 'contraseña',
    'per_hour': 'por hora',
    'per_item': 'por {item}',
    'performed': 'realizados',
    'performed_female': 'realizada',
    'performeds_female': 'realizadas',
    'permission': 'permiso',
    'permission_plural': 'permisos',
    'permissions_list': 'lista de permisos',
    'phone_number': 'teléfono',
    'photo': 'foto',
    'please_try_again_contact_support': 'Por favor, inténtalo de nuevo. Si el problema persiste, ponte en contacto con soporte.',
    'point': 'punto',
    'points': 'puntos',
    'portfolio': 'cartera',
    'portfolio_farms': 'granjas de cartera',
    'possible_removal': 'posible remoción',
    'power_failure': 'fallo de alimentación',
    'ppi': 'PPI',
    'ppi_animal': 'PPI animal',
    'ppi_herd': 'PPI rebaño',
    'pre_calving': 'antes del preparto',
    'pre_calving_event': 'evento de preparto',
    'pre_calving_event_plural': 'eventos de preparto',
    'prediction_of': 'previsión de {item}',
    'predominant_breed': 'raza predominante',
    'pregnancy_diagnosis': 'diagnóstico de preñez',
    'pregnancy_pre_calving': 'preñez preparto',
    'pregnancy_rate': 'tasa de preñez',
    'pregnant': 'preñada',
    'pregnant-dry': 'preñada seca',
    'pregnant-pre-delivery': 'preparto',
    'premature': 'prematuro',
    'previous_clinical_opinion': 'opinión clínica anterior',
    'previous_comment': 'comentario anterior',
    'primary': 'primaria',
    'primary_plural': 'primarias',
    'primiparous': 'primíparas',
    'print': 'imprimir',
    'print_chart': 'imprimir el gráfico',
    'printing': 'Generar archivo para imprimir...',
    'problem_cows': 'Vacas problema',
    'processed_at': 'validado en',
    'processed_successfully': 'procesado con éxito',
    'processed_with_errors': 'procesado con errores',
    'processing_information': 'analizando su solicitud',
    'production': 'producción',
    'production_analysis': 'análisis de producción',
    'production_details': 'detalles de producción',
    'production_register': 'registro de producción',
    'production_slash_rumination': 'producción/rumiación',
    'production_total': 'producción total',
    'productive_ranking': 'ranking productivo',
    'profile_and_intake': 'perfil y consumo',
    'programmed': 'programados',
    'project': 'proyecto',
    'project_informations': 'información del proyecto',
    'project_type': 'tipo de proyecto',
    'projection_lactating_cows': 'proyección de vacas en lactancia',
    'projects': 'proyectos',
    'prostaglandin': 'PG',
    'protein_percentage': 'Proteína (%)',
    'protocol': 'protocolo',
    'protocol_add_animal': 'añadir animales al protocolo',
    'protocol_details': 'detalles del protocolo',
    'protocol_model_subtitle': 'Registre aquí la información de los modelos de protocolos de IATF, TETF y PG.',
    'protocol_plural': 'protocolos',
    'protocol_remove_animal': 'sacar animales del protocolo',
    'protocol_start': 'inicio del protocolo',
    'protocol_subtitle': 'Registra aquí la información de los protocolos FTAI, ETTF y PG',
    'protocoled_animals': 'protocolo animales',
    'PS': 'obs.',
    'push_up_needed': 'necesita empuje',
    'pushing': 'empujar',
    'quantity_supplied': 'cantidad suministrada',
    'quarter_abbreviation_left-back': 'PI',
    'quarter_abbreviation_left-front': 'AI',
    'quarter_abbreviation_right-back': 'PD',
    'quarter_abbreviation_right-front': 'AD',
    'quarter_description_left-back': 'posterior izquierdo',
    'quarter_description_left-front': 'anterior izquierdo',
    'quarter_description_right-back': 'posterior derecho',
    'quarter_description_right-front': 'anterior derecho',
    'queued': 'inicializado',
    'queued_at': 'en cola',
    'quick_tip': 'consejo rapido',
    'rag': 'RAG',
    'rags': 'RAGS',
    'raising_infirmary': 'enfermería de terneros',
    'reactivation_cowconnect': 'reactivar CowConnect',
    'reactivation_monitoring': 'reactivar monitoreo',
    'read_later': 'ver después',
    'real_time': 'tiempo real',
    'rearing_raising': 'Crianza y Recría',
    'reason_text': 'motivo',
    'receiving_packages': 'recepción de paquetes',
    'reception': 'recepción',
    'recommendation': 'recomendación',
    'recommended_hour': 'tiempo recomendado expirado hace {item} hora',
    'recommended_hour_plural': 'tiempo recomendado expirado hace {item} horas',
    'reconnected': 'reconectadas',
    'recover_this_register': 'recuperar este registro',
    'recovered': 'recuperados',
    'recovered_event': 'evento recuperado',
    'redirect_timer': 'En {time} {unit} serás redirigido',
    'redirecting_to_farm': 'redireccionando a la granja',
    'regional-station': 'estación regional',
    'register': 'registro',
    'register_another_swap': 'registrar otro cambio',
    'register_item': 'registrar {item}',
    'register_item_updated_success_male': '{item} registrado/actualizado con éxito',
    'register_more_details': 'quiero registrar más detalles',
    'register_new_animal': 'registrar nuevo animal',
    'registered_at_date': 'registrado el {date}',
    'registered_by': 'registrado por',
    'registered_losses': 'pérdidas registradas',
    'registration_data': 'datos de registro',
    'registration_of': 'registro {item}',
    'reinstate_contract': 'reactivación de contratos',
    'reject': 'rechazar',
    'related_batches': 'lotes relacionados',
    'relationship': 'relación',
    'relationship_type': 'Tipo de relación',
    'release': 'liberar',
    'release_notes': 'notas de lanzamiento',
    'release_to_reproduction': 'liberación para la reproducción',
    'reload': 'recargar',
    'remove_condition': 'remover condición',
    'remove_group': 'remover grupo',
    'remove_item': 'remover {item}',
    'remove_message': 'eliminar mensaje',
    'remove_rag': '¿realmente deseas eliminar RAG {item}?',
    'remove_row': 'remover línea',
    'remove_tokenized_animal': 'eliminar el animal de la lista de animales tokenizados',
    'removed_animals': 'animales removidos',
    'removed_female': 'removida',
    'renewal_cowconnect': 'renovación CowConnect',
    'renewal_monitoring': 'renovación Monitoreo',
    'renewals': 'renovaciones',
    'replace': 'intercambios',
    'replace_item': 'sustituir {item}',
    'replace_records': 'corregir los registros',
    'replacement_rate': 'tasa de sustitución',
    'replacement_request': 'solicitud de cambio',
    'replay_later': 'responder más tarde',
    'report_cause_of_error': 'Para ayudar a nuestro equipo, informe lo que hizo para causar este error.',
    'reported_at': 'reportado en',
    'reproduction': 'reproducción',
    'reproduction_event': 'evento de reproducción',
    'reproduction_event_plural': 'eventos de reproducción',
    'reproduction_event_this': 'este evento de reproducción',
    'reproduction_restriction': 'restricción de reproducción',
    'reproduction_status': 'estado de reproducción',
    'reproductive_distribution': 'distribución reproductiva',
    'reproductive_evaluation': 'evaluación reproductiva',
    'reproductive_event_history': 'historial de eventos reproductivos',
    'reproductive_management': 'manejo reproductivo',
    'reproductive_protocol': 'protocolo reproductivo',
    'reproductive_protocols': 'protocolos reproductivos',
    'required_field': 'este campo es obligatorio',
    'reset_config': 'restablecer configuración',
    'reset_item': 'Reiniciar {item}',
    'reset_zoom': 'restablecer zoom',
    'resources': 'recursos',
    'response_error': '¡ooops!',
    'response_info': '¡informe!',
    'response_percentage': 'porcentaje de respuesta',
    'response_success': '¡éxito!',
    'response_warning': '¡atención!',
    'responsible': 'responsable',
    'restart_time': 'tiempo de reinicio',
    'restore': 'restaurar',
    'restore_event': 'restaurar evento',
    'restore_item': 'restaurar {item}',
    'restore_this': 'restaurar esto {item}',
    'results': 'resultados',
    'results_analysis': 'análisis de los resultados',
    'return_heats': 'celos de retorno',
    'revert_ignore_temporarily': 'revertir ignorar temporalmente',
    'revert_ignore_temporarily_confirm_message': '¿Estás seguro de que deseas revertir "Ignorar temporalmente" este animal?',
    'revert_item': 'revertir {item}',
    'revision': 'revisión',
    'role': 'rol',
    'role_permissions': 'permisos del rol',
    'role_plural': 'roles',
    'root': 'root',
    'row': 'línea',
    'row_index': 'índice',
    'rumination': 'rumia',
    'rumination_max_index': 'índice máximo de rumia',
    'rumination_min_index': 'índice mínimo de rumiación',
    'rumination_profile': 'perfil de rumiación',
    'sample': 'muestra',
    'sanitary-protocol': 'protocolo sanitario',
    'save': 'guardar',
    'save_config': 'guardar configuración',
    'save_file_in_format': 'guardar el archivo en formato "{format}"',
    'SBC_network_interface': 'interfaz de red SBC',
    'SBC_status': 'estado SBC',
    'SBC_version': 'versión SBC',
    'SBC_voltage': 'voltaje SBC',
    'SCC_x1000': 'CCS (x1000)',
    'schedule_protocol': 'programación de protocolos',
    'scheduleds_female': 'programadas',
    'search': 'buscar',
    'search_back_to_all': 'volver a todas las categorías',
    'search_filter_all': 'todos',
    'search_filter_pages': 'páginas',
    'search_in_the_menu': 'busca en el menú...',
    'search_no_recent_example': 'intenta buscar por **animales**, **lotes**, **collares** o **páginas**',
    'search_no_recent_title': 'nada por aquí todavía',
    'search_recent': 'recientes',
    'search_shortcut_navigate': 'navegar',
    'search_shortcut_open': 'abrir',
    'search_system_accesses_description': 'lista de granjas',
    'secondary': 'secundario',
    'secondary_plural': 'secundario',
    'security': 'seguridad',
    'see_again': 'ver de nuevo',
    'see_all': 'ver todo',
    'see_item': 'ver {item}',
    'see_less': 'ver menos',
    'see_list_of_item': 'ver la lista de  {item}',
    'seed': 'seed',
    'select_all': 'seleccionar todo',
    'select_date_of_milk_production_instruction': 'Seleccione la fecha referente a la producción láctea del archivo a importar.',
    'select_exported_file': 'Seleccione el archivo de software exportado {software}.',
    'select_exported_file_dairyplan': 'seleccione el archivo de software exportado {software} e rellene el nombre de las columnas según las indicaciones del equipo de Éxito del cliente (Brinco, Nome, L, Pai, Mae, DtNasc, Reg, Parto, IA, Hora, TouroIA, Stat, DtDg, DtSec, Prod).',
    'select_interval': 'selecciona un rango',
    'select_one_item_female': 'selecciona una {item}',
    'select_one_item_male': 'selecciona uno {item}',
    'select_option_and_all_related_options': 'Selecciona esta opción para incluir todas las opciones relacionadas',
    'select_spreadsheet_type': 'seleccione el tipo de hoja de cálculo',
    'selected_data': 'datos seleccionados',
    'selected_maximum_number_of_items_allowed': 'ha alcanzado el límite máximo de {max} elementos permitidos.',
    'selection_summary': 'Resumen de selección',
    'selection_summary_subtitle': 'Visualice y valide los criterios aplicados a sus filtros.',
    'semen_type': 'tipo de semen',
    'send': 'enviar',
    'sending': 'enviando...',
    'serial': 'número de serie',
    'serum_proteins': 'proteínas del suero',
    'service': 'servicio',
    'service_at': 'Servicio en',
    'service_cycles': 'ciclos de servicio',
    'service_plural': 'servicios',
    'service_rate': 'tasa de servicio',
    'service_type': 'tipo de servicio',
    'services_monthly': 'servicios mensuales',
    'services_weekly': 'servicios semanales',
    'set_as_main': 'establecer como estándar',
    'settings': 'configuraciones',
    'SFN_percentage': 'ESD (%)',
    'short_description': 'descripción corta',
    'short_months_apr': 'abr',
    'short_months_aug': 'ago',
    'short_months_dec': 'dic',
    'short_months_feb': 'feb',
    'short_months_jan': 'ene',
    'short_months_jul': 'jul',
    'short_months_jun': 'jun',
    'short_months_mar': 'mar',
    'short_months_may': 'may',
    'short_months_nov': 'nov',
    'short_months_oct': 'oct',
    'short_months_sep': 'sep',
    'shortcuts': 'atajos',
    'show_help': 'haga clic para mostrar ayuda',
    'show_item': 'mostrar {item}',
    'showing_quantity_of_total_results': 'mostrando {quantity} de {total} resultados encontrados',
    'sign_out_of_account': 'cerrar sesión de la cuenta',
    'signals_and_symptoms': 'Signos / Síntomas',
    'signed_contracts': 'contratos firmados',
    'signs': 'señales',
    'site_in_maintenance': '¡Volvemos enseguida!',
    'site_in_maintenance_text': 'el servicio se encuentra temporalmente no disponible. Nuestro equipo ya está trabajando para restablecer el acceso y que puedas volver a utilizar el sistema en breve.',
    'skip_item': 'omitir {item}',
    'software_download_spreadsheet': 'descarga la hoja de cálculo {spreadsheetName} del software {software}.',
    'software_name': 'CowMed',
    'solid_components': 'componentes sólidos',
    'solid_percentage': 'Sólidos (%)',
    'something_went_wrong': 'algo salió mal. Inténtalo de nuevo.',
    'son_plural': 'hijos',
    'sorry_dont_find_results': 'lo sentimos, no encontramos resultados para',
    'sort_by': 'ordenar por',
    'source_review': 'revisión de origen',
    'source_voltage': 'tensión de alimentación',
    'spacing': 'espaciado',
    'spacious': 'espacioso',
    'SPC_x1000': 'CBT (x1000)',
    'special_requirements': 'requisitos especiales',
    'specific_configuration': 'configuración específica',
    'stage_losses': 'pérdidas del período',
    'start_date': 'fecha de inicio',
    'start_sync': 'fecha de inicio (primer manejo)',
    'started': 'procesando',
    'started_at': 'inicializado en',
    'state': 'estado',
    'status': 'estado',
    'status_normalization': 'normalización de estado',
    'stillbirth': 'mortinato',
    'storage': 'inventario',
    'strength': 'fuerza',
    'stress_light': 'estrés ligero',
    'stress_moderate_to_severe': 'estrés moderado a severo',
    'stress_severe': 'estrés severo',
    'stress_zone': 'zona de estrés',
    'submit_feedback': 'enviar comentarios',
    'success': 'completado con éxito',
    'success_with_warnings': 'terminado con errores',
    'supply_time': 'tiempo de suministro',
    'support': 'soporte',
    'support_notes': 'notas de apoyo',
    'suspected_loss': 'pérdidas sospechadas',
    'suspended_account_message': 'parece que su cuenta ha sido suspendida, por favor, póngase en contacto con el equipo de atención al cliente y el estado de su registro. Hasta pronto!',
    'suspended_account_title': 'sin acceso a las granjas!',
    'sync_now': 'sincronizar ahora',
    'sync_now_message': 'la sincronización con {item} se iniciará ahora. ¿Desea continuar?',
    'synchronized': 'sincronizado',
    'system': 'sistema',
    'system_users': 'usuarios del sistema',
    'table_export_warning': "El tamaño de esta tabla excede el límite de impresión. Para una mejor experiencia, utilice la función 'Exportar'.",
    'table_view': 'tabla',
    'tag_collar_as': 'marcar collar como',
    'tag_collar_as_plural': 'marcar collares como',
    'tank_analysis': 'análisis de tanque',
    'tank_analysis_abreviation': 'adt',
    'technology_by': 'tecnología por',
    'tecnical_review': 'revisión técnica',
    'temperature': 'temperatura',
    'temperature-humidity-index': 'índice de temperatura-humedad',
    'temporary_suspension': 'suspensión temporal',
    'term_no_results_found': 'tu búsqueda por **{term}** no obtuvo ningún resultado. Intenta con un término diferente.',
    'term_of_contract': 'plazo del contrato',
    'test_plural': 'pruebas',
    'thermal_comfort': 'comodidad térmica',
    'thermal_comfort_and_rest': 'confort térmico y descanso',
    'thermal_stress': 'estrés térmico',
    'thi': 'THI',
    'THI_and_intake': 'THI y consumo',
    'this_report_helps_our_team_fix_the_problem': 'este informe ayuda a nuestro equipo a solucionar el problema',
    'time_second': 'segundo',
    'time_second_plural': 'segundos',
    'timezone': 'huso horario',
    'tip_from_female': 'consejo de {item}',
    'title': 'título',
    'to_verify': 'comprobar',
    'token': 'token',
    'token_consumption': 'consumo de tokens',
    'tokenizable_animals': 'animales tokenizables',
    'tokenized_animals': 'animales tokenizados',
    'tokens': 'tokens',
    'tool_plural': 'herramientas',
    'topology': 'topología {item}',
    'total': 'total',
    'total_consumption': 'consumo total',
    'total_occurrences': 'ocurrencias totales',
    'training_plural': 'entrenamientos',
    'transacted_data': 'datos transaccionados',
    'transaction_plural': 'movimientos',
    'transactional_emails': 'correos electrónicos transaccionales',
    'transfer_of_passive_immunity': 'transferencia de inmunidad pasiva (TIP)',
    'transition': 'transición',
    'treated_cases': 'casos tratados',
    'treated_male': 'tratado',
    'treatment': 'tratamiento',
    'treatment_plural': 'tratos',
    'treatments': 'medicamentos',
    'type': 'tipo',
    'type_description': 'descripción del tipo',
    'type_to_find': 'escriba para iniciar la búsqueda',
    'type_your_message_here': 'escribe tu mensaje aquí',
    'unanswered_companies': 'empresas sin respuesta',
    'unanswered_farms': 'granjas sin respuesta',
    'unarchive_item': 'desarchivar {item}',
    'uncheck_all': 'desmarcar todo',
    'undo_discart': 'deshacer descarte',
    'undo_removal': 'deshacer eliminación',
    'unit': 'unidad {item}',
    'unit_plural': 'unidades',
    'unlinked_activity': 'actividad no relacionada',
    'unlinked_points': 'puntos no enlazados',
    'unmark': 'desmarcar',
    'unmark_as_unfit': 'desmarcar como',
    'unmonitored_plural': 'no monitoreados',
    'unprocessed': 'no procesado',
    'unseen': 'no visto',
    'unsupported_image_format': 'formato de imagen no compatible, utilice: {formats}',
    'untag_collar': 'desmarcar collar',
    'untag_collar_message': '¿está seguro de que desea eliminar el marcador del collar?',
    'untag_collar_message_plural': '¿está seguro de que desea eliminar el marcador de los collares?',
    'untag_collar_plural': 'desmarcar collares',
    'update_available': 'actualización disponible',
    'update_frequency': 'frecuencia de actualización',
    'update_item': 'editar {item}',
    'update_registration': 'actualización del registro',
    'updated_at': 'actualizado',
    'updated_by': 'actualizado por',
    'upload_file_through_field_below': 'cargue el archivo usando el campo a continuación',
    'upload_image': 'subir imagen',
    'UPS_output': 'Salida del UPS',
    'UPS_QoS': 'QoS UPS',
    'UPS_status': 'UPS (backup)',
    'upsell-churn': 'Upsell / Churn',
    'urea': 'urea',
    'urea_percentage': 'urea (%)',
    'use_history': 'historia de uso',
    'used_treatment': 'tratamiento utilizado',
    'useful_links': 'enlaces útiles',
    'user': 'usuario',
    'user_environment': 'ambiente de usuario',
    'user_informations': 'informaciones del usuario',
    'user_name': 'nombre de usuario',
    'user_plural': 'usuarios',
    'uses_location': 'utiliza la ubicación',
    'validated_at': 'validado en',
    'validity': 'vigencia',
    'value': 'valor',
    'variability': 'variabilidad',
    'variation_short': 'var.',
    'ventilation_system': 'Sistema de ventilación',
    'version': 'versión',
    'version_updated_at': 'la versión ha sido actualizada en',
    'VIC': 'VIC',
    'vic_ai_title': 'VIC IA',
    'vic_chat_audio_error_conversion_failed': 'No fue posible procesar el audio. Graba nuevamente',
    'vic_chat_audio_error_microphone_denied': 'Permite el acceso al micrófono en el navegador para grabar audio',
    'vic_chat_audio_error_microphone_unavailable': 'No hay micrófono disponible para grabar audio',
    'vic_chat_audio_error_too_short': 'Audio demasiado corto. Graba nuevamente',
    'vic_chat_audio_limit_reached': 'Grabación finalizada: límite de 1 minuto alcanzado',
    'vic_chat_audio_listening': 'VIC está escuchando tu audio',
    'vic_chat_audio_message': 'Mensaje de audio',
    'vic_chat_audio_recording': 'grabando',
    'vic_chat_audio_stop': 'detener',
    'vic_chat_composer_placeholder': 'Escribe tu mensaje aquí',
    'vic_chat_composer_usage_limit_reached': 'Límite mensual de VIC alcanzado. Se reinicia el {date}',
    'vic_chat_conversations_empty': 'ningún chat',
    'vic_chat_conversations_favorites': 'favoritos',
    'vic_chat_conversations_recent': 'recientes',
    'vic_chat_delete_conversation_confirm_label': 'confirmar eliminación',
    'vic_chat_delete_conversation_label': 'eliminar conversación',
    'vic_chat_disclaimer': 'VIC puede cometer errores. Verifica la información importante en el sistema.',
    'vic_chat_fab_label': 'abrir chat con VIC',
    'vic_chat_favorite_conversation_label': 'marcar como favorito',
    'vic_chat_message_edit_label': 'editar mensaje',
    'vic_chat_message_status_cancelled': 'cancelado',
    'vic_chat_message_status_error': 'error',
    'vic_chat_message_status_pending': 'pendiente',
    'vic_chat_message_status_read': 'leído',
    'vic_chat_message_status_sending': 'enviando',
    'vic_chat_message_status_sent': 'enviado',
    'vic_chat_message_status_streaming': 'respondiendo',
    'vic_chat_plan_limits_description': 'Tu plan tiene un límite mensual de tokens para conversar con VIC.',
    'vic_chat_plan_limits_monthly_usage': 'Uso de la granja',
    'vic_chat_plan_limits_remaining': '{percentage}% restante',
    'vic_chat_plan_limits_resets_in': 'Se reinicia el {date}',
    'vic_chat_plan_limits_total_usage': '{used} de {total} tokens',
    'vic_chat_plan_limits_user_usage': '{tokens} tokens · {percentage}% del límite',
    'vic_chat_plan_limits_users_usage': 'Uso por usuario',
    'vic_chat_rename_conversation_label': 'renombrar conversación',
    'vic_chat_retry': 'reintentar',
    'vic_chat_settings_avatar_placement': 'Identificación de VIC',
    'vic_chat_settings_avatar_placement_hidden': 'oculta',
    'vic_chat_settings_avatar_placement_inline': 'avatar junto al nombre',
    'vic_chat_settings_avatar_placement_name': 'solo el nombre',
    'vic_chat_settings_avatar_placement_side': 'avatar junto al mensaje',
    'vic_chat_settings_display_description': 'Ajuste el ancho, el tamaño de la fuente y cómo se identifica a VIC en los mensajes.',
    'vic_chat_settings_display_title': 'Visualización',
    'vic_chat_settings_drawer_width': 'Ancho del panel',
    'vic_chat_settings_drawer_width_large': 'grande',
    'vic_chat_settings_drawer_width_medium': 'mediano',
    'vic_chat_settings_drawer_width_small': 'pequeño',
    'vic_chat_settings_font_size': 'Tamaño de la fuente',
    'vic_chat_settings_font_size_extra_large': 'extra grande',
    'vic_chat_settings_font_size_extra_small': 'extra pequeño',
    'vic_chat_settings_font_size_large': 'grande',
    'vic_chat_settings_font_size_medium': 'mediano',
    'vic_chat_settings_font_size_small': 'pequeño',
    'vic_chat_settings_page_width': 'Ancho de la conversación',
    'vic_chat_settings_page_width_full': 'total',
    'vic_chat_settings_page_width_large': 'grande',
    'vic_chat_settings_page_width_medium': 'mediano',
    'vic_chat_settings_page_width_small': 'pequeño',
    'vic_chat_stop_reply_label': 'detener respuesta',
    'vic_chat_suggestion_alerts': 'Alertas',
    'vic_chat_suggestion_alerts_value': '¿Qué alertas están abiertas en la granja hoy?',
    'vic_chat_suggestion_animals_batches': 'Animales y lotes',
    'vic_chat_suggestion_animals_batches_value': '¿Cómo están mis animales y lotes?',
    'vic_chat_suggestion_help': 'Resuelve tus dudas',
    'vic_chat_suggestion_help_value': '¿Cómo puede VIC ayudarme en el día a día de la granja?',
    'vic_chat_suggestion_routines': 'Rutinas',
    'vic_chat_suggestion_routines_value': '¿Qué rutinas tengo para hoy?',
    'vic_chat_token_usage_label': 'tokens utilizados',
    'vic_chat_tool_approval_fallback': 'revisa la acción antes de continuar',
    'vic_chat_tool_approved': 'autorizaste esta acción',
    'vic_chat_tool_awaiting_confirmation': 'esperando confirmación',
    'vic_chat_tool_denied': 'rechazaste esta acción',
    'vic_chat_tool_error': 'no fue posible completar la acción',
    'vic_chat_tool_generic_title': 'acción de la VIC',
    'vic_chat_tool_manage_animal_collars_title': 'vincular collares',
    'vic_chat_tool_running': 'ejecutando la acción',
    'vic_chat_tool_success': 'acción completada',
    'vic_chat_tool_unanswered': 'sin respuesta',
    'vic_chat_unfavorite_conversation_label': 'quitar de favoritos',
    'vic_gpt_title': 'VIC GPT',
    'vic_routine_subtitle': 'Rutinas y protocolos de la granja',
    'vic_usage_limit_placeholder': 'límite de uso de VIC alcanzado este mes',
    'vic_usage_limit_text': 'Esta granja alcanzó el límite de uso de VIC en este período. Podrás conversar nuevamente a partir del {date}.',
    'vic_usage_limit_title': 'límite de uso alcanzado',
    'view': 'ver',
    'view_all': 'ver todo',
    'view_all_count': 'ver todos los {count}',
    'view_all_notifications': 'ver todas las notificaciones',
    'view_all_tasks': 'ver todos los procesos',
    'view_full_routine': 'ver rutina completa',
    'view_history': 'ver historial',
    'view_item': 'ver {item}',
    'view_score_chart': 'ver gráfico de puntuación',
    'viewData': 'ver tabla de datos',
    'visible_columns': 'columnas visibles',
    'visual_heat': 'celo visual',
    'voluntary_waiting_period_heats': 'celos PEV',
    'VWP_hint': 'PEV (recién parida)',
    'waiting': 'esperando {item}',
    'waiting_conditions': 'Esperando condiciones...',
    'waiting_time': 'tiempo de espera',
    'waiting-artificial-insemination': 'RI-IATF',
    'waiting-embryo-transfer': 'RI-TETF',
    'weaning': 'destete',
    'webleite': 'Web + Leite',
    'webleite_overview':
        'Web + Leite es un sistema informatizado de control y gestión orientado a la ganadería lechera, utilizado por asociaciones de criadores. Una vez que el productor tiene acceso, puede integrarlo con CowMed.\n\n### Cómo funciona\n\n1. Acceda a Web + Leite para generar un nuevo token.\n2. En el menú **Integrações**, acceda a la opción **Autenticadores**.\n3. Haga clic en el botón **"+"** para crear un nuevo acceso, con el nombre CowMed.\n4. Web + Leite generará un token, una secuencia larga de letras y números. Copie ese token.\n5. Aquí en CowMed, haga clic en **Conectar** y siga los pasos de configuración usando el token copiado de Web + Leite.\n\n### Datos disponibles\n\n- Análisis de tanque (lectura)\n- Control lechero individual (lectura)',
    'weekdays_friday': 'viernes',
    'weekdays_monday': 'lunes',
    'weekdays_saturday': 'sábado',
    'weekdays_sunday': 'domingo',
    'weekdays_thursday': 'jueves',
    'weekdays_tuesday': 'martes',
    'weekdays_wednesday': 'miércoles',
    'weight': 'peso',
    'welcome': 'bienvenido',
    'what_are_you_looking_for': '¿qué estás buscando?',
    'what_do_you_want_to_register': '¿Qué quieres grabar?',
    'with_attach': 'con vinculo',
    'with_diagnosis': 'con diagnóstico',
    'with_withdrawal_period': 'con período de retiro',
    'without_diagnosis': 'sin diagnóstico',
    'without_diagnostic_text': 'no se ha comunicado ningún diagnóstico en los últimos {item} días.',
    'without_information': 'sin información',
    'without_leading_zeros': 'sin ceros a la izquierda',
    'without_withdrawal_period': 'sin período de retiro',
    'write_message': 'escriba su mensaje',
    'year': 'año',
    'yes': 'sí',
    'your_software_was_updated': 'su software tiene nuevas actualizaciones',
    'zip_code': 'código postal',
} as const

export { es }
